import SmartText from "./SmartText.jsx";
import SmartPics from "./SmartPics.jsx";
import './styles/Smart.scss';


function Smart() {


    return (
        <section className="smart">
            <div className="smartBook">
                <SmartText />
                <SmartPics />
            </div>
        </section>
    )
}
            
export default Smart;